module.exports = require("murmurhash");